export default __webpack_public_path__ + "static/media/verificationOperatorCounter.84274819.jpg";